import { useState } from "react";

import Button from "components/Button";
import HollowButton from "components/HollowButton";

import styles from "./styles.module.scss";

interface Props {
  title: string;
  loading?: boolean;
  onClose: () => void;
  onApply: (password: string) => void;
}

// Nadanie hasła radnemu. Hasło ustawia administrator Biura rady — tak jak w Magistracie,
// gdzie konta portalu zakładano z poziomu kartoteki radnych.
//
// Powtórzenie hasła jest tu istotne: administrator wpisuje je „w ciemno" i przekazuje
// radnemu poza systemem, więc literówka ujawniłaby się dopiero przy nieudanym logowaniu.

const PasswordModal = ({ title, loading = false, onClose, onApply }: Props) => {
  const [password, setPassword] = useState("");
  const [repeat, setRepeat] = useState("");

  const tooShort = !!password && password.length < 8;
  const mismatch = !!repeat && password !== repeat;
  const canApply = password.length >= 8 && password === repeat;

  return (
    <div className={styles.overlay} onMouseDown={onClose}>
      <div className={styles.modal} onMouseDown={(e) => e.stopPropagation()}>
        <div className={styles.modalTitle}>{title}</div>

        <div className={styles.modalBody}>
          <div className={styles.field}>
            <label className={styles.fieldLabel}>Nowe hasło</label>
            <input
              className={styles.textInput}
              type="password"
              value={password}
              autoFocus
              autoComplete="new-password"
              onChange={(e) => setPassword(e.target.value)}
            />
            {tooShort && (
              <span className={styles.fieldError}>
                Hasło musi mieć co najmniej 8 znaków.
              </span>
            )}
          </div>

          <div className={styles.field}>
            <label className={styles.fieldLabel}>Powtórz hasło</label>
            <input
              className={styles.textInput}
              type="password"
              value={repeat}
              autoComplete="new-password"
              onChange={(e) => setRepeat(e.target.value)}
            />
            {mismatch && <span className={styles.fieldError}>Hasła są różne.</span>}
          </div>

          <span className={styles.fieldLabel}>
            Zmiana hasła kończy wszystkie otwarte sesje tego radnego w portalu.
          </span>
        </div>

        <div className={styles.modalFooter}>
          <HollowButton text="Anuluj" onClick={onClose} />
          <Button
            text="Ustaw hasło"
            loading={loading}
            disabled={!canApply}
            onClick={() => canApply && onApply(password)}
          />
        </div>
      </div>
    </div>
  );
};

export default PasswordModal;
